import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  sync(event) {
    const value = event.target.value

    this.inputTargets.forEach(input => {
      if (input !== event.target) {
        input.value = value
      }
    })
  }
}
